const coins = require('../coins');
const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = [{
    dataIndex: 0,
    id: '3pool',
    name: '3pool',
    lpTokenInfo: {
        name: '3poolCurve',
        symbol: '3poolCrv',
    },
    assets: 'DAI+USDC+USDT',
    coins: [
        coins.dai,
        coins.usdc,
        coins.usdt,
    ],
    addresses: {
        swap: '0x7f90122BF0700F9E7e1F688fe926940E8839F353',
        lpToken: '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
        gauge: '0x78CF256256C8089d68Cde634Cf7cDEFb39286470',
    },
    gaugeVersion: 3, // No CRV rewards
    hasNoCRVRewards: true,
    additionalRewards: [{
        key: 'CRV3POOL',
        name: 'CRV',
        amountDataKey: 'crv3poolRewards',
        rewardTokenAddress: '0x712b3d230f3c1c19db860d80619288b1f0bdd0bd',
        rewardTokenDecimals: 18,
        rewardTokenCoingeckoId: 'curve-dao-token',
        rewardContract: '0x6c09f6727113543fd061a721da512b7efcdd0267'
    },{
        key: 'STAKE3POOL',
        name: 'GNO',
        rewardTokenAddress: '0x9c58bacc331c9aa871afd802db6379a98e80cedb',
        rewardTokenDecimals: 18,
        rewardTokenCoingeckoId: 'gnosis',
        rewardContract: '0x6c09f6727113543fd061a721da512b7efcdd0267'
    }],
}, {
    dataIndex: 1,
    id: 'rai',
    name: 'rai',
    lpTokenInfo: {
        name: 'raiCurve',
        symbol: 'raiCrv',
    },
    coingeckoInfo: {
        id: 'rai',
        symbol: 'RAI',
        referenceAssetId: 'dollar',
    },
    assets: 'RAI+3pool',
    isMetaPool: true,
    coins: [
        coins.rai,
        coins.tricrv,
    ],
    metaCoins: [
        coins.dai,
        coins.usdc,
        coins.usdt,
    ],
    addresses: {
        swap: '0x85bA9Dfb4a3E4541420Fc75Be02E2B42042D7e46',
        lpToken: '0x36390a1Ae126f16C5D222CB1F2AB341dD09f2FEC',
        deposit: '0xdf6eb52c4A9d7d5964b918c50D47a643Fd7D3D4c',
    },
    hasNoGauge: true,
    isRiskier: true,
    riskLevel: 3,
    isStablePoolWithSpecialUnpeggedAssets: true, // Special stable pool implementation to pair rai+usd
}, {
    dataIndex: 2,
    id: 'eureusd',
    name: 'eureusd',
    lpTokenInfo: {
        name: 'eureusdCurve',
        symbol: 'eureusdCrv',
    },
    coingeckoInfo: {
        id: 'eure',
        symbol: 'EURe',
        referenceAssetId: 'dollar',
    },
    assets: 'EURe+3pool',
    isMetaPool: true,
    coins: [
        coins.eure,
        coins.tricrv,
    ],
    metaCoins: [
        coins.dai,
        coins.usdc,
        coins.usdt,
    ],
    addresses: {
        swap: '0x056C6C5e684CeC248635eD86033378Cc444459B0',
        lpToken: '0x0CA1C1eC4EBf3CC67a9f545fF90a3795b318cA4a',
        deposit: '0xE3FFF29d4DC930EBb787FeCd49Ee5963DADf60b6',
    },
    hasNoGauge: true,
    isRiskier: true,
    riskLevel: 3,
}];
